package top.wcpe.allincore.ui.runtime.internal.math

/**
 * 十进制精确的 step 对齐：`stepValue * steps + minValue`（FR-UI-021 批E，Slider 步进量化）。
 *
 * JVM actual 用 BigDecimal.valueOf 十进制精确乘加（与迁移前逐位一致，规避 0.1*3 类
 * 双精度噪声）；JS actual 用双精度乘加后按 1e10 粒度舍入近似（常见 step 精度下与 JVM 一致）。
 */
internal expect fun decimalStepAlign(stepValue: Double, steps: Long, minValue: Double): Double

/** `Math.round(double)` 的语义忠实版（floor(x+0.5)；kotlin.math.round 对负半整数 ties 方向不同）。 */
internal fun mathRoundCompat(v: Double): Long = kotlin.math.floor(v + 0.5).toLong()
